import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { AnalyticsPopupTile } from '../AnalyticsPopupTile/AnalyticsPopupTile';
import { AnalyticsSimpleTile } from '../AnalyticsSimpleTile/AnalyticsSimpleTile';
import { BarChartVerticalWrapper } from '../../../components/Charts/BarChartVerticalWrapper';
import NoDataChart from '../../../components/Charts/NoDataChart';
import { getBarChartGradients } from '../../../components/Charts/getBarChartGradients';
import composedChartColors from '../../../../const/composedChartColors';
import { AnalyticsSimpleTileCollapser } from '../AnalyticsSimpleTile/AnalyticsSimpleTileCollapser';


class AnalyticsUserSessionsBarChartTile extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.showData = this.showData.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.report?.data?.chartsDataUpdateTs !== nextProps.report?.data?.chartsDataUpdateTs) {
            return true;
        }
        if (JSON.stringify(this.props.settings) !== JSON.stringify(nextProps.settings)) {
            return true;
        }
        return false;
    }

    showData() {
        console.info('AnalyticTile DATA', this.props);
    }

    render() {
        const {
            environment,
            report,
        } = this.props;

        const chartData = report?.data?.userSessionsStats?.chartData;
        const firstClickEvents = report?.data?.userSessionsStats?.firstClickEvents;
        const micAllowedEvents = report?.data?.userSessionsStats?.micAllowedEvents;

        return (
            <AnalyticsSimpleTile {...this.props} >
                <div
                    className={`analytic-tile ${environment}`}
                    onClick={this.showData}>
                    <AnalyticsSimpleTileCollapser {...this.props}>
                        <div className="analytic-tile_header">
                            Sessions
                        </div>
                    </AnalyticsSimpleTileCollapser>
                    <div className="analytic-tile_legend">
                        <div className="analytic-tile_legend-dot-1" /> Sessions: <span className="analytic-tile_total">{chartData?.reduce((acc, b) => acc + b.sessionCount, 0) || '—'}</span>
                        <span className="with-pointer"
                            data-tip="Sessions with the Alan button clicked"
                            data-for="btnClickedTooltip"
                            data-class="tutor-light-tooltip tutor-no-arrow-tooltip">
                            Button clicked: <span className="analytic-tile_total">{firstClickEvents || '—'}</span>
                            <ReactTooltip id="btnClickedTooltip" /></span>
                        <span className="with-pointer"
                            data-tip="Sessions with the microphone allowed"
                            data-for="micAllowedTooltip"
                            data-class="tutor-light-tooltip tutor-no-arrow-tooltip">
                            Mic allowed: <span className="analytic-tile_total">{micAllowedEvents || '—'}</span>
                            <ReactTooltip id="micAllowedTooltip" /></span>
                    </div>
                    <div className="analytic-tile_body">
                        <BarChartVerticalWrapper>
                            {chartData?.length > 0 ?
                                <ResponsiveContainer width="100%" height="100%">
                                    <BarChart data={chartData}>
                                        {getBarChartGradients()}
                                        <CartesianGrid strokeDasharray="1 3" vertical horizontal />
                                        <XAxis dataKey="name" />
                                        <YAxis dataKey="sessionCount" />
                                        <Tooltip content={<UserSessionsTooltip environment={environment} />} />
                                        <Bar dataKey="sessionCount" fill={`url(#${environment}ColorVerticalExternal)`} />
                                    </BarChart>
                                </ResponsiveContainer> :
                                <NoDataChart data={chartData} />}
                        </BarChartVerticalWrapper>
                    </div>
                </div>
            </AnalyticsSimpleTile>
        );
    }
}


function UserSessionsTooltip({ active, payload, environment }) {
    let data;
    let internalValStyle = {};
    let externalValStyle = {};
    if (environment) {
        internalValStyle = { backgroundColor: composedChartColors[environment][0] };
        externalValStyle = { backgroundColor: composedChartColors[environment][1] };
    }

    if (active && payload && payload.length) {
        data = payload[0].payload;
        return (
            <div className="stats-tooltip">
                <div className="stats-tooltip_time">
                    {data.name}
                </div>
                <div>
                    <span className="tooltip-legend">Sessions: {data.sessionCount}</span>
                </div>
            </div>
        );
    }
    return null;
}

export default AnalyticsPopupTile(AnalyticsUserSessionsBarChartTile);
